export interface BuildConfiguratorUrlOpts {
    baseUrl: string;
    deadlineId: number | null;
    segment?: string;
}

export const buildConfiguratorUrl = ({ baseUrl, deadlineId, segment }: BuildConfiguratorUrlOpts): string => {
    if (!deadlineId) return baseUrl;
    const tail = segment ? `/${segment}` : '';
    return `${baseUrl}/deadline/${deadlineId}${tail}`;
};
